import de from './de.json'
import en from './en.json'

import coreDE from '@professocial/professocialCore/src/shared/translations/locales/de.json'
import coreEN from '@professocial/professocialCore/src/shared/translations/locales/en.json'

import networkContentDE from '@professocial/professocialNetworkContent/src/shared/translations/locales/de.json'
import networkContentEN from '@professocial/professocialNetworkContent/src/shared/translations/locales/en.json'

import facebookSettingsDE from '@professocial/professocialFacebookSettings/src/shared/translations/locales/de.json'
import facebookSettingsEN from '@professocial/professocialFacebookSettings/src/shared/translations/locales/en.json'

import postingDE from '@professocial/professocialPosting/src/shared/translations/locales/de.json'
import postingEN from '@professocial/professocialPosting/src/shared/translations/locales/en.json'

import topicsDE from '@professocial/professocialTopics/src/shared/translations/locales/de.json'
import topicsEN from '@professocial/professocialTopics/src/shared/translations/locales/en.json'

import statisticsDE from '@professocial/professocialStatistics/src/shared/translations/locales/de.json'
import statisticsEN from '@professocial/professocialStatistics/src/shared/translations/locales/en.json'

import accountsDE from '@professocial/professocialAccounts/src/shared/translations/locales/de.json'
import accountsEN from '@professocial/professocialAccounts/src/shared/translations/locales/en.json'

const fbSettingsDE = { ...facebookSettingsDE, facebookSettingsCommon: { ...facebookSettingsDE.facebookSettingsCommon, ...de.facebookSettingsCommon } }
const coreSettingsDE = { ...coreDE, coreSettings: { ...coreDE.coreSettings, ...de.coreSettings } }

localStorage.setItem('language', 'de')

const resources = {
  de: Object.assign(de, coreDE, networkContentDE, fbSettingsDE, postingDE, topicsDE, statisticsDE, accountsDE, coreSettingsDE),
  en: Object.assign(en, coreEN, networkContentEN, facebookSettingsEN, postingEN, topicsEN, statisticsEN, accountsEN),
}

export default resources
